import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import initializeIcons from '@/util/icons';
import './css/main.css';
import createMockData from '@/util/createMockData';

async function initialize() {
    Vue.config.productionTip = false;
    initializeIcons();

    if (process.env.NODE_ENV === 'mock') {
        await createMockData(store);
        console.log('Mock data created.');
    }

    // autosave every 30 seconds
    setInterval(async () => await store.dispatch('autosave/autosave'), 30000);

    // autosave when user closes window
    window.addEventListener('beforeunload', async (e) => {
        if (store.state.project.dirty) {
            await store.dispatch('autosave/autosave');
            e.preventDefault();
            e.returnValue = 'Project saved successfully!';
            return 'Project saved successfully.';
        }
    });

    // noinspection JSUnusedGlobalSymbols
    new Vue({
        router,
        store,
        render: (h) => h(App),
    }).$mount('#app');
}

initialize().catch((e) => { throw e; });
